module.exports = __webpack_public_path__ + "static/media/Section-1-2-3.22295d3b.mp3";